<header class="app-header navbar">
  <div class="header-logo">
    <a class="navbar-brand" href="/">
      <img class="navbar-brand-full" src="assets/images/logo.png" width="140"  alt="SomDenWeb">
      <img class="navbar-brand-minimized" src="assets/images/logo.png" width="30" alt="SomDenWeb">
    </a>
  </div>
</header>
